export enum FILE_TYPE {
    IMAGE = 1,
}
